import { Box, Typography } from '@mui/material';

import type { DropdownListItem } from '@verantos-dev/shared-components';
import {
  ComboBox,
  ApiWorkflowDialog,
  TextField,
  RadioButton,
} from '@verantos-dev/shared-components';

import { useCreateProjectModal } from '../../hooks/useCreateProjectModal';

export const CreateProjectModal = () => {
  const {
    title,
    closeCreateProjectModal,
    createProjectModalContentMessages,
    onSubmit,
    releasesError,
    isLoading,
    releases,
    isInternalUser,
    organizations,
    selectedOrganization,
    onChangeOrganization,
    onRetryInitialLoadingFetch,
    createProjectError,
    isCreateProjectLoading,
    projectName,
    onChangeProjectName,
    isValidToSubmit,
    onChangeRelease,
    selectedRelease,
    apiWorkflowDialogMessages,
    onRedirectAfterSubmit,
    isVisible,
    onChangeIsVisible,
    showVisibility,
  } = useCreateProjectModal();

  return (
    <ApiWorkflowDialog
      id="createProjectModel"
      title={title}
      dialogMessages={apiWorkflowDialogMessages}
      onClose={closeCreateProjectModal}
      onSubmit={onSubmit}
      onRetryInitialLoadingFetch={onRetryInitialLoadingFetch}
      onRetrySubmit={onSubmit}
      isValidForSubmit={isValidToSubmit}
      isInitialLoading={isLoading}
      isSubmitting={isCreateProjectLoading}
      initialLoadingError={releasesError}
      submittingError={createProjectError}
      onRedirectAfterSubmit={onRedirectAfterSubmit}
      hideDisplayButtonsOnSuccess
    >
      <Box style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box sx={(theme) => ({ height: theme.spacing(1) })} />
        <TextField
          id="project-name-input"
          width="auto"
          displayLabel={createProjectModalContentMessages.projectNameLabel}
          value={projectName}
          placeholder={createProjectModalContentMessages.projectNamePlaceholder}
          onChange={onChangeProjectName}
          beepMaxCharacters
          maxCharacters={60}
          displayNumCharacter
        />
        <ComboBox
          id="dialogDropdown"
          width="auto"
          label={createProjectModalContentMessages.datasetLabel}
          placeholder={createProjectModalContentMessages.datasetPlaceholder}
          value={selectedRelease as DropdownListItem | DropdownListItem[] | undefined}
          options={
            releases
              ? releases.map((release) => ({
                  value: release.releaseId,
                  displayValue: release.releaseName,
                }))
              : []
          }
          onChange={onChangeRelease}
          showTooltip
        />
        {isInternalUser && (
          <>
            <ComboBox
              id="dialogDropdown"
              width="auto"
              label={createProjectModalContentMessages.organizationLabel}
              placeholder={createProjectModalContentMessages.organizationPlaceholder}
              value={selectedOrganization}
              options={(organizations || []).map(({ organizationId, displayName }) => ({
                value: organizationId,
                displayValue: displayName,
              }))}
              disableClearable={true}
              onChange={onChangeOrganization}
            />
            {showVisibility && (
              <Box sx={(theme) => ({ px: theme.spacing(6) })}>
                <Typography variant="caption">
                  {createProjectModalContentMessages.visibilityLabel}
                </Typography>
                <Box sx={{ flexDirection: 'row', display: 'flex', flexShrink: 1 }}>
                  <RadioButton
                    id="false"
                    label={createProjectModalContentMessages.visibilityDisabled}
                    width="small"
                    checked={!isVisible}
                    onChange={onChangeIsVisible}
                  />
                  <RadioButton
                    id="true"
                    label={createProjectModalContentMessages.visibilityEnabled}
                    width="small"
                    checked={isVisible}
                    onChange={onChangeIsVisible}
                  />
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </ApiWorkflowDialog>
  );
};
